const partnerTypes = [
  {
    icon: 'ri-store-2-line',
    title: '新創品牌',
    desc: '協助從零開始的新創團隊，從配方開發、包裝設計到量產，快速建立自有品牌。',
    tags: ['彈性客製', '配方研發', '品牌建立'],
    color: '#4CAF50',
  },
  {
    icon: 'ri-shopping-bag-line',
    title: '電商品牌',
    desc: '提供快速交期與彈性訂量，符合電商靈活上新需求，協助打造市場熱賣爆款。',
    tags: ['快速交期', '彈性訂量', '電商爆款'],
    color: '#66BB6A',
  },
  {
    icon: 'ri-hospital-line',
    title: '藥局通路',
    desc: '熟悉藥局通路法規需求，提供符合健康食品規範的產品，強化通路競爭力。',
    tags: ['法規符合', '通路需求', '品質保證'],
    color: '#81C784',
  },
  {
    icon: 'ri-global-line',
    title: '國際品牌',
    desc: '協助國際品牌在台或向外拓展市場，提供符合出口規範的產品。',
    tags: ['多國出口', '法規協助', '國際市場'],
    color: '#A5D6A7',
  },
];

export default function PartnerTypesSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            合作對象
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            我們服務哪些合作夥伴？
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            康永生技服務範圍廣泛，不論您處於哪個發展階段，我們都能提供合適的代工合作方案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {partnerTypes.map((p) => (
            <div
              key={p.title}
              className="bg-[#f7faf7] rounded-2xl p-7 hover:border-green-200 border border-transparent hover:-translate-y-1 transition-all duration-300"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl mb-5"
                style={{ backgroundColor: `${p.color}20` }}
              >
                <i className={`${p.icon} text-2xl`} style={{ color: p.color }} />
              </div>
              <h3 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-3">{p.title}</h3>
              <p className="text-gray-500 text-[0.9375rem] leading-[1.75] mb-4">{p.desc}</p>
              <div className="flex flex-wrap gap-2">
                {p.tags.map((tag) => (
                  <span
                    key={tag}
                    className="text-[0.75rem] px-2.5 py-1 rounded-full font-medium"
                    style={{ backgroundColor: `${p.color}15`, color: p.color }}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
